module.exports = __webpack_public_path__ + "img/shipping-onboarding-example@2x.affcfcfb.png";